import {
  detectLocale,
  getBrandName as getBrandNameIntl,
} from '@quintoandar/js-intl';

export const getBrandName = () => {
  const locale = detectLocale() || 'pt-BR';
  return getBrandNameIntl(locale);
};

export const getProductName = () => 'QuintoAndar';

export const getCozyThemeName = () => 'DEFAULT';
